module.exports = __webpack_public_path__ + "media/images/gratuit-58e8496345b5a96676be8d0d25e56885.svg";